import React, {useEffect, useRef} from "react"
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from "@material-ui/core/MenuItem";
import NumberFormat from 'react-number-format';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import {Tooltip, withStyles} from "@material-ui/core";
import {ProjectSaveService} from "../services/ProjectSaveService";
import KnxGenerateProjectService from "../services/knx_ausstattung/GenerateProjectService";
import KonventionellGenerateProjectService from "../services/konventionell_ausstattung/GenerateProjectService";
import HomeGenerateProjectService from "../services/home_ausstattung/GenerateProjectService";
import products from "../data/products.json";
import GenerateProductList from "../services/GenerateProductListService";
import {GenerateImagePath} from "../services/GenerateImagePath";
import uarrh from "../images/arrow_up_hover.svg";
import darrh from "../images/arrow_down_hover.svg";
import matrix_files from "../data/home_dateinamen.json"
import initialProjectData from "../data/initialProjectData.json";
import uarr from "../images/arrow_up.svg";
import {sha1} from 'crypto-hash';
import boerseImg from "../images/projektboerse.png";
import Popover from "@material-ui/core/Popover";
import CloseIcon from "@material-ui/icons/Close";
import boerseCircle from "../images/circle-outline.svg";
import boerseCircleCheck from "../images/checkmark-circle-outline.svg";
import boerseLogo from "../images/projektboese-logo-jung.svg";
import boerseLogo2 from "../images/groups/logo-pb.svg";
import boerseLogox from "../images/groups/x.svg";
import jungLogo from "../images/alunio/alunio-logo.svg";
import {ProjectBoerseService} from "../services/ProjektBoerseService";
import arrow_right from "../images/groups/arrow_right.svg";
import page2Checker from "../images/groups/page2-checker.svg";
import pb01 from "../images/groups/group1020.svg";
import pb02 from "../images/groups/group990.svg";
import pb03 from "../images/groups/group989.svg";
import pb04 from "../images/groups/group832.svg";
import iconStep1 from "../images/groups/icon_step1.svg";
import iconStep2 from "../images/groups/icon_step2.svg";
import iconStep3 from "../images/groups/icon_step3.svg";
import iconStep4 from "../images/groups/icon_step4.svg";
import arrow_down from "../images/groups/arrow_down.svg";
import stepDivider from "../images/groups/step_divider.svg";
// import img01 from "../images/projektboerse/01.jpg";
// import img02 from "../images/projektboerse/02.jpg";
// import img03 from "../images/projektboerse/03.jpg";
// import img04 from "../images/projektboerse/04.webp";
// import img05 from "../images/projektboerse/05.webp";
// import img06 from "../images/projektboerse/06.webp";
// import img07 from "../images/projektboerse/07.webp";
// import img08 from "../images/projektboerse/08.jpg";
// import img09 from "../images/projektboerse/09.jpg";

export default function StepFiveComponent({project, updateProject, showProjectPrices, foerderungs, PriceBox, trackingObj, equipmentData2, equipmentData4, isKonventionell, isHome, isMyJung=false, jumpTo, isIFrame, setPrCode, prCode, lastSum, setLastSum}){
    const [selectedRoomFilter, setSelectedRoomFilter] = React.useState({});
    const [selectedProductFilter, setSelectedProductFilter] = React.useState(undefined);
    const [foerderung1, setFoerderung1] = React.useState(true);
    const [foerderung2, setFoerderung2] = React.useState(false);
    const [foerderung3, setFoerderung3] = React.useState(false);
    const [inClipboard, setInClipboard] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isFunktionenOpen, setIsFunktionenOpen] = React.useState(false);
    const [loadingRoomBook, setLoadingRoomBook] = React.useState(false);
    const [loadingFunctions, setLoadingFunctions] = React.useState(false);
    const [planungsCode, setPlanungsCode] = React.useState(null);
    const [loadingCSV, setLoadingCSV] = React.useState(false);
    const [roomProductFilters, setRoomProductFilters] = React.useState([]);
    const [selectedRoomProductFilter, setSelectedRoomProductFilter] = React.useState(undefined);
    const [selectedFunctionCat, setSelectedFunctionCat] = React.useState(undefined);
    const funcImgUrl = "https://www.projekt14.de/austausch/quick_j/home/functions/";
    const [currentSha1, setCurrentSha1] = React.useState('');
    const [partnerForm, setPartnerForm] = React.useState(null);
    const isProjektboerse = true;//!!process.env.REACT_APP_PROJEKTBOERSE;
    const [boerseOpen, setBoerseOpen] = React.useState(false);
    const [boersePage, setBoersePage] = React.useState(1);
    const [boerseElement, setBoerseElement] = React.useState(null);
    const [projektOrt, setProjektOrt] = React.useState(false);
    const [boerseDatum, setBoerseDatum] = React.useState('');
    const [currentToken, setCurrentToken] = React.useState('');
    const boerseRef = useRef(null);
    useEffect(() => {
        setBoerseElement(boerseRef.current);
        let d = new Date();
        setBoerseDatum(d.getDate() + '.' + d.getMonth() + '.' + d.getFullYear());
    }, [boerseRef]);
    let totals;
    let pCode = null;
    let pCodeInterval = 0;
    let callFunction = '';
    if (foerderungs) {
        if (foerderung1 !== foerderungs.foerderung1) { setFoerderung1(foerderungs.foerderung1); }
        if (foerderung2 !== foerderungs.foerderung2) { setFoerderung2(foerderungs.foerderung2); }
        if (foerderung3 !== foerderungs.foerderung3) { setFoerderung3(foerderungs.foerderung3); }
    }
    useEffect(() => {
        // if (!isIFrame) { setTimeout(() => {document.body.style.overflow = 'unset'; }, 200); }
    }, []);
    async function getSha1(code = '') {
        const ending = "uO`}y.fS@&!n\\k";
        const value = code + '' + ending;
        const result = await sha1(value);
        setCurrentSha1(result);
    }
    function useProjectService(projectIn){
        if(project.generatedProject !== undefined){
            return project;
        }
        switch(projectIn.projectType){
            case "knx":
                return KnxGenerateProjectService(projectIn, products);
            case "konventionell":
                return KonventionellGenerateProjectService(projectIn, products);
            case "home":
                return HomeGenerateProjectService(projectIn, products);
            default:
                return project;
        }
    }
    const currentProject = useProjectService(project);
    var productListAndFiltersAll = GenerateProductList(currentProject, undefined, undefined, roomProductFilters, selectedRoomProductFilter);
    var productListAndFilters = GenerateProductList(currentProject, selectedRoomFilter, selectedProductFilter, roomProductFilters, selectedRoomProductFilter);
    function calculatePrices(begProductList, all = false){

        let produktpreis = 0;
        let nettopreis = 0;
        let mwst = 0;
        let beg = 0;
        let gesamtsumme = 0;
        const productList = all ? productListAndFiltersAll.productList : productListAndFilters.productList;

        productList.forEach( g => {
            g.products.filter(i => i.Preis >= 0).forEach(p => {
                p.count = parseInt(p.count, 10) || 0;
                nettopreis += (p.Preis*p.count);
                mwst += ((p.Preis*0.19)*p.count);
                produktpreis = p.Preis*1.19;
                if(foerderung1 === true && foerderung2 === true && foerderung3 === true){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-35'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.6;
                        beg += (produktpreis*p.count)*0.4;
                    }else if(product['BEG-20'] === 1 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.75;
                        beg += (produktpreis*p.count)*0.25;
                    }else if(product['BEG-20'] === 0 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.95;
                        beg += (produktpreis*p.count)*0.05;
                    }else{
                        gesamtsumme += produktpreis * p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === false && foerderung3 === true){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-20'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.75;
                        beg += (produktpreis*p.count)*0.25;
                    }else if(product['BEG-20'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.95;
                        beg += (produktpreis*p.count)*0.05;
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === true && foerderung3 === false){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(product['BEG-35'] === 1){
                        gesamtsumme += (produktpreis*p.count)*0.65;
                        beg += (produktpreis*p.count)*0.35;
                    }else if(product['BEG-20'] === 1 && product['BEG-35'] === 0){
                        gesamtsumme += (produktpreis*p.count)*0.8;
                        beg += (produktpreis*p.count)*0.2;
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
                else if(foerderung1 === true && foerderung2 === false && foerderung3 === false){
                    const product = begProductList.find(pl => pl.Artikelnummer.toString() === p.Artikelnummer.toString());
                    if(
                        product['BEG-20'] === 1 &&
                        (
                            currentProject.projectType === 'knx'
                            || currentProject.projectType === 'easy'
                            || currentProject.projectType === 'home'
                        )
                    ){
                        gesamtsumme += (produktpreis * p.count)*0.8;
                        beg += (produktpreis*p.count)*0.2;
                    }else if(currentProject.projectType === 'konventionell'){
                        gesamtsumme += (produktpreis*p.count);
                    }else{
                        gesamtsumme += produktpreis*p.count;
                    }
                }
            })
        })

        nettopreis = nettopreis / 100;
        mwst = (((nettopreis * 1.19) * 19) / 119);
        beg = beg / 100;
        gesamtsumme = gesamtsumme / 100;
        produktpreis = nettopreis * 1.19;

        nettopreis = round(nettopreis);
        mwst = round(mwst);
        beg = round(beg);
        gesamtsumme = round(gesamtsumme);
        produktpreis = round(produktpreis);
        return [nettopreis, mwst, beg, gesamtsumme, produktpreis];
    }
    let calculatedValues = calculatePrices(products);
    productListAndFiltersAll = {...productListAndFiltersAll, calculatedValues: calculatePrices(products, true)};
    function onOpenClose(e) {
        e.preventDefault(); e.stopPropagation();
        if (isOpen) {
            // console.log('scrollto')
            if ('parentIFrame' in window) {
                window.parentIFrame.scrollToOffset(0, 0);
            } else {
                window.scrollTo(0, 0);
            }
        }
        setIsOpen(!isOpen);
        // if ('parentIFrame' in window && !wasOpen) {
        //     jumpTo(e.pageY);
        // }
        return false;
    }
    function onFunktionenToggle() {
        setIsFunktionenOpen(!isFunktionenOpen);
    }
    function selectProductFilterValue(item, allRoomsItem = undefined){
        if (!allRoomsItem) { setSelectedProductFilter(item); return; }
        productListAndFilters = {
            ...productListAndFilters,
            roomFilterList: productListAndFilters.roomFilterList.map(rf => rf.rooms.map(roomFilter => {
                if (roomFilter.id !== allRoomsItem.key) { return roomFilter; }
                setSelectedProductFilter({
                    ...roomFilter,
                    productFilter: allRoomsItem.productFilter,
                });
                return {
                    ...roomFilter,
                    productFilter: allRoomsItem.productFilter,
                };
            }))
        };
        setRoomProductFilters(productListAndFilters.roomFilterList);
    }
    function selectRoomFilerValue(floor, room, prodFilter){
        if(floor !== undefined && room !== undefined) {
            if (selectedProductFilter && selectedProductFilter.id) { setSelectedProductFilter(undefined); }
            setSelectedRoomFilter({floor: floor.id, room: room.id});
        }else if (floor !== undefined && room === undefined){
            setSelectedRoomFilter({floor: floor.id});
        }else if (floor === undefined && room === 'all') {
            setSelectedRoomFilter({floor: 'all', room: 'all'});
            setSelectedRoomProductFilter(prodFilter);
        }else{
            setSelectedRoomFilter({floor: undefined, room: undefined});
        }
    }
    function generateRoomFilter(roomFilterList){
        const list = [];
        list.push(<MenuItem value="alle" key={"alle"} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"} onClick={e => selectRoomFilerValue(undefined, undefined)}>Gesamtübersicht</MenuItem>)
        list.push(<MenuItem value="all" key={"all"} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"} onClick={e => selectRoomFilerValue(undefined, 'all')}>Alle Räume</MenuItem>)
        roomFilterList.forEach( f=>{
            list.push(<ListSubheader value={f.id} key={f.id} style={{fontSize:"inherit"}} className={"roomFilterFloorItem"}
                                     onClick={e => selectRoomFilerValue(f)}
            >{f.name}</ListSubheader>);
            f.rooms.forEach(r => list.push(<MenuItem value={r.id} key={r.id} style={{fontSize: "inherit"}} className={"roomFilterRoomItem"}
                                                     onClick={e => selectRoomFilerValue(f, r)}>{r.name}</MenuItem>));
        });
        return list;
    }
    function generateProductFilter(catFilterList, allRoomsItem = undefined){
        const list = [];
        list.push(<MenuItem value={"productFilter-all"} key={"productFilter-all"} style={{fontSize: "inherit"}} className={"productFilterItem"} onClick={e => selectProductFilterValue(undefined)}>Alle Produkte</MenuItem>);
        catFilterList.forEach((item) =>
            list.push(<MenuItem value={"productFilter-" + item.id} key={"productFilter-" + item.id}
                                style={{fontSize: "inherit"}} className={"productFilterItem"}
                                onClick={e => selectProductFilterValue(item.id)}>{item.name}</MenuItem>)
        );
        return list;
    }
    const BtnProjektBoerse = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--blueColor)",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
            },
            borderRadius: 0,
            height: "45px",
            lineHeight: "45px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const BtnProjektBoerse2 = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "#001dec",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
            },
            borderRadius: "20px !important",
            height: "33px",
            lineHeight: "33px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "0 15px !important",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const ColorButton4 = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--blueColor)",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
            },
            borderRadius: 0,
            height: "45px",
            lineHeight: "45px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const ColorButton4Disabled = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--textColor)",
            '&:hover': {
                backgroundColor:"var(--textColor)",
            },
            cursor: 'not-allowed',
            borderRadius: 0,
            height: "45px",
            lineHeight: "45px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const ColorButton41 = withStyles((theme) => ({
        root: {
            color: "var(--weiss)",
            backgroundColor: "var(--blueColor)",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
            },
            borderRadius: 0,
            height: "45px",
            lineHeight: "15px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    const ColorButton42 = withStyles((theme) => ({
        root: {
            color: "var(--blueColor)",
            backgroundColor: "var(--weiss)",
            '&:hover': {
                backgroundColor:"var(--blueColorHover)",
                color: "var(--weiss)",
            },
            borderRadius: '3px',
            height: "45px",
            lineHeight: "15px",
            fontSize: "inherit",
            textAlign: "center",
            padding: "10px",
            flex: 1,
            textTransform: "inherit"
        },
    }))(Button);
    // const ColorButton5active = withStyles((theme) => ({
    //     root: {
    //         color: "var(--weiss)",
    //         backgroundColor: "var(--blueColor)",
    //         '&:hover': {
    //             backgroundColor:"var(--blueColorHover)",
    //             color: "var(--weiss)",
    //         },
    //         cursor: "pointer",
    //         height: "10px",
    //         alignContent: "center",
    //         padding: "23px",
    //         fontSize: "16px",
    //         fontWeight: "normal",
    //         marginTop: "0",
    //         marginRight: "2%",
    //         marginLeft: "2%",
    //         textAlign: "center",
    //         borderRadius: "8px",
    //         textTransform: "inherit",
    //         width: "46%",
    //     },
    // }))(Button);
    function generateGroupList(productList = undefined, justWithProducts = false){
        let plist = [];
        const lst = productList || productListAndFilters.productList;
        const optional = productListAndFilters.optionalProducts;
        lst.forEach( g => {
           if(selectedProductFilter === undefined || selectedProductFilter === g.name) {
               plist.push(<div className={"group"} key={g.name}>
                   <div className={"groupHeader"}>
                       {g.name}
                   </div>
                   {isMyJung ? <div className="tableHeader row myjung">
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>Produktbezeichnung</div>
                           </div>
                       </div>
                       <div className="col-2 phoneNoShow" style={{textAlign: "left"}}>Artikelnummer</div>
                       <div className="col-2 phoneNoShow">Anzahl</div>
                       <div className="col-2">UVP</div>
                   </div> : <div className={"tableHeader row phone-first-column-big"}>
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>Produktbezeichnung</div>
                           </div>
                       </div>
                       <div className="col-6" style={{textAlign: "right"}}>Anzahl</div>
                   </div>}
                   <div className={"groupContent 353"}>
                       {
                           generateProduktListForGroup(g, productList, isMyJung)
                       }
                   </div>
               </div>)
           } else if (selectedProductFilter && selectedProductFilter.products) {
               if (!justWithProducts || (justWithProducts && g.products.length))
               plist.push(<div className={"group"} key={g.name}>
                   <div className={"groupHeader"}>
                       {g.name}
                   </div>
                   <div className={"groupContent 365"}>
                       {
                           generateProduktListForGroup(g, productList, isMyJung)
                       }
                   </div>
               </div>)
           }
        });
        let list2 = [];
        if (optional.length > 0) {
            list2.push(<div className={"border-bottom"} style={{paddingTop: '15px'}}>
                <div className={"section-title"} style={{marginBottom: '5px'}}>Optional</div>
            </div>);
        }
        optional.forEach( g => {
           if(selectedProductFilter === undefined || selectedProductFilter === g.name) {
               list2.push(isMyJung ?
               <div className={"group"} key={g.name}>
                   <div className={"groupHeader"}>
                       {g.name}
                   </div>
                   <div className="tableHeader row">
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>Produktbezeichnung</div>
                           </div>
                       </div>
                       <div className="col-2" style={{textAlign: "left"}}>Artikelnummer</div>
                       <div className="col-2">Anzahl</div>
                       <div className="col-2">UVP</div>
                   </div>
                   <div className={"groupContent"}>
                       {
                           generateProduktListForGroupOptional(g, g.products)
                       }
                   </div>
               </div>
               :
               <div className={"group"} key={g.name}>
                   <div className={"groupHeader"}>
                       {g.name}
                   </div>
                   <div className="tableHeader row">
                       <div className="col-6">
                           <div className={"row"}>
                               <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                               <div className={"col-11"}>Produktbezeichnung</div>
                           </div>
                       </div>
                       <div className="col-6" style={{textAlign: "right"}}>Anzahl</div>
                   </div>
                   <div className={"groupContent"}>
                       {
                           generateProduktListForGroupOptional(g, g.products)
                       }
                   </div>
               </div>
               )
           } else if (selectedProductFilter && selectedProductFilter.products) {
               if (!justWithProducts || (justWithProducts && g.products.length))
               list2.push(<div className={"group"} key={g.name}>
                   <div className={"groupHeader"}>
                       {g.name}
                   </div>
                   <div className={"groupContent"}>
                       {
                           generateProduktListForGroupOptional(g, g.products)
                       }
                   </div>
               </div>)
           }
        });
        if (list2.length) {
            plist.push(<div className={"optional-products"}><>{list2}</></div>);
        }
        if (!plist.length) { plist.push(<div className={"row"} style={{margin: "15px 0"}}>Keine Produkte</div>); }
        return plist;
    }
    function generatePListForRoom(g) {
        const list = [];
        g.products.forEach(pr => {
            list.push(isMyJung ?
            <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                <div className="col-6" key={pr.Artikelnummer}>
                    <div className={"row"} style={{maxHeight: "50px"}}>
                        <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                            <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                 style={{maxWidth: "50px", maxHeight: "50px"}}/>
                        </div>
                        <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                    </div>
                </div>
                <div className={"col-2 artNr"}
                     style={{padding: "0 0px", textAlign: "left"}}>{pr.Artikelnummer}</div>
                <div className="text-right col-2">{pr.count}</div>
                <div className="text-right col-2">{pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                displayType={'text'} suffix={" €"}
                                                                thousandSeparator={"."}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                decimalSeparator={","}/> : "Ohne Angabe"}
                </div>
            </div> :
            <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                <div className="col-6" key={pr.Artikelnummer}>
                    <div className={"row"} style={{maxHeight: "50px"}}>
                        <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                            <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                 style={{maxWidth: "50px", maxHeight: "50px"}}/>
                        </div>
                        <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                    </div>
                </div>
                <div className="text-right col-6">{pr.count}</div>
            </div>);
        });
        if (!g.products.length) { list.push(<div className={"row"}>Keine Produkte</div>);}
        return list;
    }
    function GetRLR(g, r) {
        return <div className={"room-container"} key={g.name + ' - ' + r.name}>
            <div className={"groupHeader"}>{g.name} - {r.name}</div>
            {isMyJung ? <div className="tableHeader row">
                <div className="col-6">
                    <div className={"row"}>
                        <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                        <div className={"col-11"}>Produktbezeichnung</div>
                    </div>
                </div>
                <div className="col-2" style={{textAlign: "left"}}>Artikelnummer</div>
                <div className="col-2">Anzahl</div>
                <div className="col-2">UVP</div>
            </div> : <div className="tableHeader row">
                <div className="col-6">
                    <div className={"row"}>
                        <div className={"col-1"} style={{maxWidth: "50px"}}></div>
                        <div className={"col-11"}>Produktbezeichnung</div>
                    </div>
                </div>
                <div className="col-6" style={{textAlign: "right"}}>Anzahl</div>
            </div>}
            <div className={"groupContent"}>{generatePListForRoom(r)}</div>
        </div>;
    }
    function GetRLRGroup(g) {
        const list = [];
        g.rooms.forEach(room => {
            if (room.products && room.products.length) {
                list.push(GetRLR(g, room));
            }
        });
        return list;
    }
    function GetRoomListRoom(props) {
        const list = [];
        const roomFilterList = props.value;
        roomFilterList.forEach( g => {
            list.push(<div className={"floor-container"} key={g.name}>
                {GetRLRGroup(g)}
            </div>);
        });
        if (!list.length) { list.push(<div className={"row"} style={{margin: "15px 0"}}>Keine Produkte</div>); }
        return list;
    }
    function generateRoomList() {
        const list = [];
        list.push(<GetRoomListRoom key={'the-room-list'} value={productListAndFilters.roomFilterList} />);
        return list;
    }
    function generateProduktListForGroup(group, isAllRooms = false){
        let rlist = [];
        const lst = isAllRooms || productListAndFilters.productList;
        lst.forEach(p => {
            if(p.name === group.name){
                p.products.forEach((pr, idx) => {
                    rlist.push(isMyJung ? <div className={p.name + " " + idx} key={pr.Artikelnummer}>
                        <div className={"row bb-2 wpadding phoneNoShow" + " " + group.name} key={pr.Artikelnummer}>
                        <div className="col-6" key={pr.Artikelnummer}>
                            <div className={"row"} style={{maxHeight: "50px"}}>
                                <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                    <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                         style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                </div>
                                <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                            </div>
                        </div>
                        <div className={"col-2 text-left"}
                             style={{padding: "0 0px", textAlign: "left"}}>{pr.Artikelnummer}</div>
                        <div className="col-2 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        <div className="text-right col-2">{pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                        displayType={'text'} suffix={" €"}
                                                                        thousandSeparator={"."}
                                                                        decimalScale={2}
                                                                        fixedDecimalScale={true}
                                                                        decimalSeparator={","}/> : "Ohne Angabe"}</div>
                    </div>
                        <div className={"row bb-2 wpadding phoneShow" + " " + group.name} key={pr.Artikelnummer}>
                            <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt="" style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                            </div>
                            <div className={"col-11 productName phone-rows"} style={{padding: "0 30px"}}>
                                <div>{pr.Bezeichnung}</div>
                                <div>Artikelnummer: {pr.Artikelnummer}</div>
                                <div>Anzahl: {pr.count}</div>
                                <div>UVP: {pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                            displayType={'text'} suffix={" €"}
                                                                            thousandSeparator={"."}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            decimalSeparator={","}/> : "Ohne Angabe"}</div>
                            </div>
                        </div>
                    </div> : <div className={p.name + " " + idx} key={pr.Artikelnummer}>
                        <div className={"row bb-2 wpadding phoneNoShow" + " " + group.name} key={pr.Artikelnummer}>
                            <div className="col-6" key={pr.Artikelnummer}>
                                <div className={"row"} style={{maxHeight: "50px"}}>
                                    <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                        <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                             style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                    </div>
                                    <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                                </div>
                            </div>
                            <div className="col-6 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        </div>
                        <div className={"row bb-2 wpadding phoneShow" + " " + group.name} key={pr.Artikelnummer}>
                            <div className="col-10" key={pr.Artikelnummer}>
                                <div className={"row"} style={{maxHeight: "50px"}}>
                                    <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                        <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                             style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                    </div>
                                    <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                                </div>
                            </div>
                            <div className="col-2 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        </div>
                    </div>);
                });
                if (!p.products.length) { rlist.push(<div className={"row"}>Keine Produkte</div>);}
            }
        })
        return rlist.length > 0 ? rlist : <div className={"row"}>Keine Produkte</div>
    }
    function generateProduktListForGroupOptional(group){
        const list = [];
        const lst = productListAndFilters.optionalProducts;
        lst.forEach(p => {
            if(p.name === group.name){
                p.products.forEach(pr => {
                    list.push(isMyJung ?
                    <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                        <div className="col-6" key={pr.Artikelnummer}>
                            <div className={"row"} style={{maxHeight: "50px"}}>
                                <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                    <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                         style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                </div>
                                <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                            </div>
                        </div>
                        <div className={"col-2 text-left"}
                             style={{padding: "0 0px", textAlign: "left"}}>{pr.Artikelnummer}</div>
                        <div className="col-2 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                        <div className="text-right col-2">{pr.Preis >= 0 ? <NumberFormat value={(pr.Preis / 100) * pr.count}
                                                                        displayType={'text'} suffix={" €"}
                                                                        thousandSeparator={"."}
                                                                        decimalScale={2}
                                                                        fixedDecimalScale={true}
                                                                        decimalSeparator={","}/> : "Ohne Angabe"}</div>
                    </div>
                    :
                    <div className={"row bb-2 wpadding"} key={pr.Artikelnummer}>
                        <div className="col-6" key={pr.Artikelnummer}>
                            <div className={"row"} style={{maxHeight: "50px"}}>
                                <div className={"col-1"} style={{minWidth: "50px", maxWidth: "50px"}}>
                                    <img src={GenerateImagePath.getPath(pr.Gtin, "")} alt=""
                                         style={{maxWidth: "50px", maxHeight: "50px", textAlign: "left"}}/>
                                </div>
                                <div className={"col-11 productName"} style={{padding: "0 30px"}}>{pr.Bezeichnung}</div>
                            </div>
                        </div>
                        <div className="col-6 text-right" style={{textAlign: "right"}}>{pr.count}</div>
                    </div>
                    );
                });
                if (!p.products.length) { list.push(<div className={"row"}>Keine Produkte</div>);}
            }
        })
        return list.length > 0 ? list : <div className={"row"}>Keine Produkte</div>
    }
    //TODO: remove fixed values
    let gesamtsumme = 5247.74;
    let mwst = 837.88; // gesamtsumme * 0.19;
    let beg = 1311.94; // gesamtsumme * 0.2;
    let gesamtsummeohnebeg = 6559.68; // gesamtsumme  + mwst;
    let nettopreis = 0;
    totals = {nettopreis: nettopreis, gesamtsummeohnebeg: gesamtsummeohnebeg, mwst: mwst, beg: beg, gesamtsumme: gesamtsumme};
    if (calculatedValues) {
        nettopreis = calculatedValues[0];
        gesamtsummeohnebeg = calculatedValues[4];
        mwst = calculatedValues[1]
        beg = calculatedValues[2];
        gesamtsumme = calculatedValues[3];
        totals = {nettopreis: nettopreis, gesamtsummeohnebeg: gesamtsummeohnebeg, mwst: mwst, beg: beg, gesamtsumme: gesamtsumme};
        showProjectPrices(totals);
    }
    if (productListAndFilters.isAllProducts) {
        productListAndFiltersAll = {...productListAndFiltersAll, totals: totals};
    }
    else {
        productListAndFiltersAll = {...productListAndFiltersAll, totals: {
                nettopreis: productListAndFiltersAll.calculatedValues[0],
                gesamtsummeohnebeg: productListAndFiltersAll.calculatedValues[4],
                mwst: productListAndFiltersAll.calculatedValues[1],
                beg: productListAndFiltersAll.calculatedValues[2],
                gesamtsumme: productListAndFiltersAll.calculatedValues[3]
        }};
    }
    const usedProducts = [];
    productListAndFilters.productList.forEach(group => {
        group.products.forEach(product => {
            usedProducts.push({itemNumber: product.Artikelnummer, itemName: product.Bezeichnung, itemCount: product.count, uvp: product.Preis});
        });
    });
    // const finalStepData = getFinalStepTracking();
    // if (project?.loadedFromCode && project.loadedFromCode !== null && project.loadedFromCode !== undefined) {
    //     let projectType = 'knx';
    //     if (isKonventionell) { projectType = 'konventionell'; }
    //     if (isHome) { projectType = 'home'; }
    //     const loadedApartmentType = initialProjectData[project.selectedMusterIx].name;
    //     calculatedValues = calculatePrices(products);
    //     nettopreis = calculatedValues[0];
    //     gesamtsummeohnebeg = calculatedValues[4];
    //     mwst = calculatedValues[1]
    //     beg = calculatedValues[2];
    //     gesamtsumme = calculatedValues[3];
    //     totals = {nettopreis: nettopreis, gesamtsummeohnebeg: gesamtsummeohnebeg, mwst: mwst, beg: beg, gesamtsumme: gesamtsumme};
    //     ProjectSaveService.saveTracking({
    //         trackingId: trackingObj.trackingId,
    //         finalStep: finalStepData,
    //         // saved: finalStepData,
    //         loadedAmount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
    //         step: 5,
    //         apartmentType: loadedApartmentType,
    //         projectType,
    //         b2b: isMyJung,
    //     }, undefined, trackingObj);
    // } else {
    //     ProjectSaveService.saveTracking({
    //         trackingId: trackingObj.trackingId,
    //         finalStep: Object.assign(finalStepData, {
    //             amount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
    //             usedProducts: usedProducts
    //         }),
    //         loadedAmount: null
    //     }, undefined, trackingObj);
    // }
    if (totals.gesamtsummeohnebeg !== lastSum) {
        setPrCode(null);
        setLastSum(totals.gesamtsummeohnebeg);
    }
    // function getFinalStepTracking() {
    //     let data = Object.assign(trackingObj.finalStep || {}, {
    //         amount: parseFloat(totals.gesamtsummeohnebeg.replace('.','').replace(',','.')) * 100,
    //         usedProducts: usedProducts,
    //         constructionProjectType : project.subProjectType || "neubau"
    //     });
    //     // step1 data
    //     if (project.selectedMusterIx !== undefined && project.selectedMusterIx !== null) {
    //         data = Object.assign(data, {apartmentType: initialProjectData[project.selectedMusterIx].name});
    //     }
    //     // step2 Data
    //     const levelName = project.selectedLevel > 2 ? 'Premium' : (project.selectedLevel > 1 ? 'Komfort' : 'Basic');
    //     data = Object.assign(data,{scopeOfEquipment: levelName});
    //     let selectedEquipments = [];
    //     project.floors.forEach(floor => {
    //         floor.rooms.forEach(room => {
    //             equipmentData2.forEach(ed => {
    //                 ed.options.forEach(opt => {
    //                     const found = selectedEquipments.filter(i => i.name === opt.name)[0];
    //                     let eq;
    //                     if (found) {
    //                         eq = Object.assign(found, {count: found.count + parseInt(room.selectedEquipment[opt.id] || 0,10)});
    //                     } else if (room.selectedEquipment[opt.id]) {
    //                         eq = {name: opt.name, count: parseInt(room.selectedEquipment[opt.id],10)};
    //                     }
    //                     if (eq) { selectedEquipments = [...selectedEquipments.filter(i => i.name !== opt.name), eq]; }
    //                 });
    //             });
    //         });
    //     });
    //     data = Object.assign(data || {}, {selectedEquipments: selectedEquipments});
    //     // step3 data
    //     let deviceSeries = [];
    //     project.floors.forEach(fl => {
    //         fl.rooms.forEach(room => {
    //             const serie = {
    //                 name: room.selectedDesign.selectedSerie.name || '',
    //                 operatingConcept: room.selectedDesign.selectedOperationConcept?.name || '',
    //                 color: room.selectedDesign.selectedColor1.colorName || ''
    //             };
    //             const found = deviceSeries.filter(i => i.name === serie.name && i.operatingConcept === serie.operatingConcept && i.color === serie.color)[0];
    //             // if (found) {
    //             //     deviceSeries = [...deviceSeries.filter(i => i.name !== serie.name || i.operatingConcept !== serie.operatingConcept || i.color !== serie.color), {...found, count: found.count + 1}];
    //             // } else {
    //             //     deviceSeries = [...deviceSeries, {...serie, count: 1}];
    //             // }
    //             deviceSeries = found ? [...deviceSeries] : [...deviceSeries, {...serie, count: 1}];
    //         });
    //     });
    //     data = Object.assign(data, {deviceSeries: deviceSeries});
    //     // step4 Data
    //     let selectedOptions = [];
    //     equipmentData4.forEach(ed => {
    //         if (ed.selectableFor === 'project') {
    //             ed.options.forEach(opt => {
    //                 const found = selectedOptions.filter(i => i.name === opt.id)[0];
    //                 let eq;
    //                 if (found) {
    //                     eq = Object.assign(found, {count: found.count + parseInt(project.selectedEquipment[opt.id] || 0,10)});
    //                 } else if (project.selectedEquipment[opt.id]) {
    //                     eq = {name: opt.id, count: parseInt(project.selectedEquipment[opt.id],10)};
    //                 }
    //                 if (eq) { selectedOptions = [...selectedOptions.filter(i => i.name !== opt.id), eq]; }
    //             });
    //         } else {
    //             project.floors.forEach(floor => {
    //                 floor.rooms.forEach(room => {
    //                     ed.options.forEach(opt => {
    //                         const found = selectedOptions.filter(i => i.name === opt.id)[0];
    //                         let eq;
    //                         if (found) {
    //                             eq = Object.assign(found, {count: found.count + parseInt(room.selectedEquipment[opt.id] || 0,10)});
    //                         } else if (room.selectedEquipment[opt.id]) {
    //                             eq = {name: opt.id, count: parseInt(room.selectedEquipment[opt.id],10)};
    //                         }
    //                         if (eq) { selectedOptions = [...selectedOptions.filter(i => i.name !== opt.id), eq]; }
    //                     });
    //                 });
    //             });
    //         }
    //     });
    //     data = Object.assign(data || {}, {selectedOptions: selectedOptions});
    //
    //     return data;
    // }
    function round(number){
        let num = Number((Math.abs(number) * 100).toPrecision(15));
        let finalNumber = Math.round(num) / 100 * Math.sign(number);
        finalNumber = finalNumber.toFixed(2);
        finalNumber = finalNumber.replace("." , ",");
        finalNumber = finalNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return finalNumber;
    }
    const HtmlTooltip2 = withStyles((theme) => ({
        tooltip: {
            backgroundColor: "var(--weiss)",
            color: "var(--color2)",
            fontSize: "14px",
            border: '1px solid transparent',
            maxWidth: '400px',
            minWidth: '130px',
            padding: "0px 7px",
            textAlign: "center",
            boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
        },
    }))(Tooltip);
    function copyInClipboard(c) {
        var textField = document.createElement('textarea')
        textField.style.position = 'absolute';
        textField.style.left = '-100000px';
        textField.innerText = c;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        setInClipboard(true);
    }
    function InClipboardNotice() {
        setTimeout(() => { setInClipboard(false); }, 1000);
        return <div className={"inClipboardNotice"}>Planungscode kopiert</div>;
    }
    function CopyIconSVG() {
        return <HtmlTooltip2 enterTouchDelay={50} title={<><p className={"copy-link-tooltip"}>Planungscode kopieren</p></>}>
            <svg viewBox="0 0 294 275.33" width="24" height="24" fill="var(--blueColor)" onClick={e => copyInClipboard(prCode ? prCode : (planungsCode ? planungsCode : pCode))}
                 style={{marginLeft: "5px", position: "relative", top: "3px", cursor: "pointer"}}
            >
                <path className="b"
                      d="M257.11,89.81h-123.87c-20.35,0-36.89,15.71-36.89,35.03v115.47c0,19.31,16.54,35.03,36.89,35.03h123.87c20.35,0,36.89-15.71,36.89-35.03V124.84c0-19.32-16.54-35.03-36.89-35.03Zm18.16,150.49c0,8.99-8.15,16.3-18.16,16.3h-123.87c-10.02,0-18.16-7.31-18.16-16.3V124.84c0-8.99,8.15-16.3,18.16-16.3h123.87c10.02,0,18.16,7.31,18.16,16.3v115.47Z"/>
                <path className="b"
                      d="M50.65,166.79h-13.76c-10.02,0-18.16-7.32-18.16-16.31V35.03c0-8.99,8.15-16.3,18.16-16.3h123.87c10.02,0,18.16,7.31,18.16,16.3v12.83c0,5.17,4.19,9.36,9.36,9.36s9.36-4.19,9.36-9.36v-12.83C197.65,15.71,181.11,0,160.76,0H36.89C16.54,0,0,15.71,0,35.03v115.47c0,19.31,16.54,35.03,36.89,35.03h13.76c5.17,0,9.36-4.19,9.36-9.36s-4.19-9.36-9.36-9.36Z"/>
            </svg>
        </HtmlTooltip2>;
    }
    const openInNewTab = (url) => {
        // ProjectSaveService.saveTracking({
        //     trackingId: trackingObj.trackingId,
        //     merchant: 1
        // }, null, trackingObj);
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) { newWindow.opener = null; }
    };
    const openUrl = (url) => {
        return () => openInNewTab(url)
    };
    function keineUmlaute(text){
        text = text.replace(/ä/gi, "ae");
        text = text.replace(/ö/gi, "oe");
        text = text.replace(/ü/gi, "ue");
        text = text.replace(/ß/gi, "ss");
        return text;
    }
    function checkCode() {
        if (planungsCode || pCode) {
            downloadPdf();
            clearInterval(pCodeInterval);
        }
    }
    function setPC(c) {
        getSha1(c).then();
        setPlanungsCode(c);
        setPrCode(c);
        setLastSum(totals.gesamtsummeohnebeg);
        // console.log('lastsum set to', totals.gesamtsumme, totals)
        pCode = c;
        if (callFunction === 'downloadCSV') { downloadCSV(); callFunction = ''; }
        if (callFunction === 'downloadFunctions') { downloadFunctions(); callFunction = ''; }
        if (callFunction === 'submitForm') { submitForm(); callFunction = ''; }
        if (callFunction === 'submitBoerseForm') { document.getElementById('boerseForm').requestSubmit(); callFunction = ''; }
    }
    function saveProject(){
        // ProjectSaveService.saveTracking({
        //     trackingId: trackingObj.trackingId,
        //     saved: trackingObj.finalStep
        // }, undefined, trackingObj);
        ProjectSaveService.saveProject(project, currentProject.projectPro || currentProject.generatedProject, currentProject, setPC);
    }
    function downloadPdf(){
        return false;
        setLoadingRoomBook(true);
        if (!planungsCode && !pCode) {
            pCodeInterval = setInterval(checkCode, 500);
            saveProject();
            return;
        }
        let filterData = productListAndFiltersAll ? productListAndFiltersAll : {...productListAndFilters, calculatedValues: calculatedValues};
        let projectRooms = [];

        if(project.floors !== undefined){
            project.floors.forEach( g => {
                if(g.rooms !== undefined) {
                    projectRooms.push(g);
                }
            })
        }
        let categories = [];
        if (filterData.isAllRooms) {
            filterData.roomFilterList.forEach(g => {
                g.rooms.forEach(r => {
                    if (r.products && r.products.length) {
                        categories.push({
                            name: g.name + " - " + r.name,
                            products: r.products.map(p => { return {...p, kategorie: g.name + " - " + r.name}; })
                        });
                    }
                });
            });
        } else {
            categories = filterData.productList;
        }
        const products = JSON.stringify(
            {
                name: project.projectName || project.name,
                projectType: project.projectType,
                productCategories: categories,
                foerderung_1: foerderung1,
                foerderung_2: foerderung2,
                foerderung_3: foerderung3,
                calculatedValues: [
                    filterData.calculatedValues[4], filterData.calculatedValues[1], filterData.calculatedValues[2], filterData.calculatedValues[3], filterData.calculatedValues[1]
                ],
                projectRooms,
                planungscode: planungsCode || pCode,
                pdfLogo: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg height="100%" stroke-miterlimit="10" style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" version="1.1" viewBox="0 0 78 20" width="100%" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs/><g id="Untitled"><path d="M34.8 12.2C34.8 12.9 34.4 15.7 29.8 15.7C25.1 15.7 24.8 12.8 24.8 12.2L24.8 3.2L21.7 3.2L21.7 15.6C21.7 15.9 21.7 16.2 22.2 16.8C22.7 17.3 23.4 17.2 23.4 17.2L36.1 17.2C36.1 17.2 36.8 17.2 37.3 16.7C37.8 16.2 37.8 15.4 37.8 15.4L37.8 3.2L34.7 3.2L34.8 12.2M33 1.4L44.1 1.4L52.2 11.2L52.2 1.4L75.2 1.4L75.2 6.8L63.8 6.8L63.8 12.3C63.8 13.4 64.7 13.9 66.7 13.9C69.3 13.9 69.7 12.9 69.7 12.3L69.7 11.1L67.2 11.1L67.2 9.3L75.1 9.3L75.1 15.6C75.1 16.5 74.8 17.3 74.1 18.1C73.2 19 72.3 19.1 71.6 19.1L60.5 19.1C59.8 19.1 58.9 19 58 18.1L58 17.9L58 19L51.4 19L44.7 11.3L44.7 19L38.9 19L38.9 17.9C38.9 17.9 38.9 18 38.8 18C37.9 18.9 37 19 36.3 19L23.4 19C22.7 19 21.8 18.9 20.9 18L20.8 17.9L20.7 18C19.8 18.9 18.9 19 18.2 19L7.1 19C6.4 19 5.5 18.9 4.6 18C3.9 17.3 3.6 16.4 3.6 15.5L3.6 9.3L9 9.3L9 12.3C9 12.9 9.3 13.9 12 13.9C14 13.9 14.9 13.3 14.9 12.3L14.9 6.8L3.6 6.8L3.6 1.4L26.6 1.4L26.6 12.3C26.6 12.9 27.1 13.9 29.8 13.9C32.5 13.9 33 12.9 33 12.3L33 1.4L33 1.4ZM39.7 3.2L39.7 17.2L42.8 17.2L42.8 8.2L44.3 8.2L52.2 17.2L57 17.2L57 3.2L54 3.2L54 14.3L52.4 14.3L43.2 3.2L39.7 3.2ZM73.3 3.2L73.3 5L61.9 5L61.9 12.3C61.9 13 62.1 15.8 66.6 15.8C71.3 15.8 71.5 12.9 71.5 12.3L71.5 11.1L73.3 11.1L73.3 15.4C73.3 15.8 73.3 16.3 73 16.6C72.6 17 72.2 17.2 71.7 17.2L60.5 17.2C60.5 17.2 59.7 17.2 59.2 16.5C58.8 16 58.9 15.4 58.9 15.4L58.9 3.2L73.3 3.2L73.3 3.2ZM5.4 3.2L5.4 5L16.8 5L16.8 12.3C16.8 13 16.6 15.8 12.1 15.8C7.4 15.8 7.2 12.9 7.2 12.3L7.2 11.1L5.4 11.1L5.4 15.4C5.4 15.8 5.4 16.3 5.7 16.6C6.1 17 6.5 17.2 7 17.2L18.2 17.2C18.2 17.2 19 17.2 19.5 16.5C19.9 16 19.8 15.4 19.8 15.4L19.8 3.2L5.4 3.2L5.4 3.2Z" fill="#000000" fill-rule="evenodd" opacity="1" stroke="none"/></g></svg>',
                fontColor: [[60, 149, 179], [60, 149, 179], [60, 149, 179]],
                font: 'Filson W04 Regular',
                coverPicture: '',
                imgPrefix: "https://www.projekt14.de/austausch/quick_j/JUNG_",
                hersteller: 'jung',
                blueColor: [91, 138, 164],
                welcome: {
                    title1: 'Willkommen bei JUNG.',
                    text1: 'JUNG steht weltweit für pures Design und zukunftsorientierte Lösungen. Seit mehr als 100 Jahren sind Innovation, Leidenschaft und Präzision wegweisend für unsere Produktentwicklungen. Licht, Beschattung, Klima, Energie, Sicherheit, Türkommunikation und Multimedia – unsere Systeme bieten die passende Lösung für jede Anforderung.',
                    image: 'welcome_bild.jpg',
                    title2: 'Qualität – Made in Germany.',
                    text2: 'Produkte und Systeme von JUNG werden weltweit als Garanten für hochwertige, verlässliche Qualität geschätzt. Entwickelt und gefertigt in den Werken in Schalksmühle und Lünen, vereinen JUNG Produkte Innovation, Funktionalität, Langlebigkeit und Ästhetik. Mit der Produktion in Deutschland setzt JUNG auf nachhaltige Entwicklungs- und Herstellungsprozesse, kurze Logistik- wege der Zulieferer und eine energieeffiziente Produktion. Präzision in der handwerklichen Verar- beitung und hohe Designqualität sorgen dafür, dass die Produkte hochwertig und robust sind. Eine lange Produktlebensdauer ist uns wichtig. Der gesamte Lebenszyklus der Architektur und der für sie verwendeten Bauprodukte rückt immer stärker in das Bewusstsein der Nutzer/innen und beeinflusst ebenso unsere Fertigung wie unsere Produkte.'
                },
                isMyJung: isMyJung
            },
            ["picture", "image", "text2", "text1", "title2", "title1", "welcome", "blueColor", "hersteller", "imgPrefix", "coverPicture", "font", "fontColor", "pdfLogo", "productCategories", "name", "id", "projectType", "products", "rooms","Artikelnummer", "Bezeichnung", "Gtin" , "Preis" , "UID-Pro", "count", "kategorie", "foerderung_1" , "foerderung_2" , "foerderung_3", "calculatedValues", "projectRooms", "selectedDesign", "selectedColor1", "selectedColor2", "colorId", "colorName", "finishName", "materialName", "selectedSerie", "planungscode", "isMyJung"]);

        fetch(
            process.env.REACT_APP_QUICK_BACKEND_URL + "/download/pflichtenheft_quick",
            {
                method: "post",
                body: products
            }
        ).then( (res)  => {
                res.blob().then((blob) => {
                    // const filename = dispo.slice(("attachment; filename=\"").length, dispo.length - 1);
                    const d = new Date();
                    d.toLocaleString();
                    let year = d.getFullYear();
                    let month = d.getMonth();
                    let day = d.getDate();

                    month += 1;

                    let filename = "JUNG";
                    if (project.projectType === "knx") { filename += '-KNX_'; }
                    if (project.projectType === "konventionell") { filename += '_'; }
                    if (project.projectType === "home") { filename += '-HOME_'; }
                    let projectname = project.projectName || project.name;
                    projectname = projectname.split(' ').join('_');
                    projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
                    filename += "Raumbuch_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
                    filename+= ".pdf";

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        "download",
                        filename,
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setLoadingRoomBook(false);
                })
            }
        )
        // ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedRoomBook: 1}, undefined, trackingObj);
    }
    function downloadFunctions(){
        setLoadingFunctions(true);
        if (!planungsCode && !pCode) {
            callFunction = 'downloadFunctions';
            saveProject();
            return;
        }
        const products = JSON.stringify(
            {
                hersteller: 'jung',
                mergePdf: true,
                pdfFiles: currentProject.functionsList,
                planungscode: planungsCode || pCode,
                additionalPages: [
                    {
                        "content": [
                            {
                                "type": "title",
                                "value": "Willkommen bei JUNG."
                            },
                            {
                                "type": "text",
                                "value": "JUNG steht weltweit für pures Design und zukunftsorientierte Lösungen. Seit mehr als 100 Jahren sind Innovation, Leidenschaft und Präzision wegweisend für unsere Produktentwicklungen. Licht, Beschattung, Klima, Energie, Sicherheit, Türkommunikation und Multimedia – unsere Systeme bieten die passende Lösung für jede Anforderung."
                            },
                            {
                                "type": "image",
                                "value": "welcome_bild.jpg"
                            },
                            {
                                "type": "title",
                                "value": "Qualität – Made in Germany."
                            },
                            {
                                "type": "text",
                                "value": "Produkte und Systeme von JUNG werden weltweit als Garanten für hochwertige, verlässliche Qualität geschätzt. Entwickelt und gefertigt in den Werken in Schalksmühle und Lünen, vereinen JUNG Produkte Innovation, Funktionalität, Langlebigkeit und Ästhetik. Mit der Produktion in Deutschland setzt JUNG auf nachhaltige Entwicklungs- und Herstellungsprozesse, kurze Logistikwege der Zulieferer und eine energieeffiziente Produktion. Präzision in der handwerklichen Verarbeitung und hohe Designqualität sorgen dafür, dass die Produkte hochwertig und robust sind. Eine lange Produktlebensdauer ist uns wichtig. Der gesamte Lebenszyklus der Architektur und der für sie verwendeten Bauprodukte rückt immer stärker in das Bewusstsein der Nutzer/innen und beeinflusst ebenso unsere Fertigung wie unsere Produkte."
                            }
                        ]
                    },
                    {
                        "content": [
                            {
                                "type": "title",
                                "value": "Die digitale Infrastruktur für Ihr Zuhause."
                            },
                            {
                                "type": "image",
                                "value": "home-3.png"
                            },
                            {
                                "type": "text",
                                "value": "JUNG HOME Geräte sind über Bluetooth® MESH verknüpft. Durch die automatische Verschlüsselung (AES-128 Bit) macht der weltweite Standard die drahtlose Datenübertragung besonders sicher. Dabei erfolgt die Kommunikation dank Bluetooth® MESH ohne Internet und Server. Die Daten werden lokal in den Geräten sicher gespeichert."
                            },
                            {
                                "type": "text",
                                "value": "Die Bluetooth® MESH Technologie ermöglicht den Aufbau eines dezentralen, drahtlosen Netzwerks. JUNG HOME Geräte wie beispielsweise Taster, Raumthermostate und Steckdosen sind darin zugleich Sender und Empfänger. Ausgelöste Befehle, wie z. B. das Ein- oder Ausschalten des Lichts, Szenen auslösen oder Temperatur erhöhen, werden von Gerät zu Gerät weitergegeben, bis das adressierte Gerät erreicht wird. Somit sind mit wenigen Geräten lange Übertragungswege, z. B. zwischen Keller und Dachboden, erreichbar."
                            },
                            {
                                "type": "text",
                                "value": "JUNG HOME ist skalierbar. Das heißt, dass Sie JUNG HOME einfach erweitern können. Funktion für Funktion. Raum für Raum. Etage für Etage. So realisieren Sie kleine bis große Anwendungen. Für die Inbetriebnahme der Anlage wird jedes Gerät mit der JUNG HOME App auf einem mobilen Endgerät eingelernt und konfiguriert."
                            }
                        ]
                    },
                    {
                        "bgImage": "home-4.png",
                        "content": [
                            {
                                "type": "title",
                                "value": "Ein System – viele Möglichkeiten."
                            }
                        ]
                    }
                ],
                blueColor: [
                    91,
                    138,
                    164
                ],
                pdfLogo: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg height="100%" stroke-miterlimit="10" style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" version="1.1" viewBox="0 0 78 20" width="100%" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs/><g id="Untitled"><path d="M34.8 12.2C34.8 12.9 34.4 15.7 29.8 15.7C25.1 15.7 24.8 12.8 24.8 12.2L24.8 3.2L21.7 3.2L21.7 15.6C21.7 15.9 21.7 16.2 22.2 16.8C22.7 17.3 23.4 17.2 23.4 17.2L36.1 17.2C36.1 17.2 36.8 17.2 37.3 16.7C37.8 16.2 37.8 15.4 37.8 15.4L37.8 3.2L34.7 3.2L34.8 12.2M33 1.4L44.1 1.4L52.2 11.2L52.2 1.4L75.2 1.4L75.2 6.8L63.8 6.8L63.8 12.3C63.8 13.4 64.7 13.9 66.7 13.9C69.3 13.9 69.7 12.9 69.7 12.3L69.7 11.1L67.2 11.1L67.2 9.3L75.1 9.3L75.1 15.6C75.1 16.5 74.8 17.3 74.1 18.1C73.2 19 72.3 19.1 71.6 19.1L60.5 19.1C59.8 19.1 58.9 19 58 18.1L58 17.9L58 19L51.4 19L44.7 11.3L44.7 19L38.9 19L38.9 17.9C38.9 17.9 38.9 18 38.8 18C37.9 18.9 37 19 36.3 19L23.4 19C22.7 19 21.8 18.9 20.9 18L20.8 17.9L20.7 18C19.8 18.9 18.9 19 18.2 19L7.1 19C6.4 19 5.5 18.9 4.6 18C3.9 17.3 3.6 16.4 3.6 15.5L3.6 9.3L9 9.3L9 12.3C9 12.9 9.3 13.9 12 13.9C14 13.9 14.9 13.3 14.9 12.3L14.9 6.8L3.6 6.8L3.6 1.4L26.6 1.4L26.6 12.3C26.6 12.9 27.1 13.9 29.8 13.9C32.5 13.9 33 12.9 33 12.3L33 1.4L33 1.4ZM39.7 3.2L39.7 17.2L42.8 17.2L42.8 8.2L44.3 8.2L52.2 17.2L57 17.2L57 3.2L54 3.2L54 14.3L52.4 14.3L43.2 3.2L39.7 3.2ZM73.3 3.2L73.3 5L61.9 5L61.9 12.3C61.9 13 62.1 15.8 66.6 15.8C71.3 15.8 71.5 12.9 71.5 12.3L71.5 11.1L73.3 11.1L73.3 15.4C73.3 15.8 73.3 16.3 73 16.6C72.6 17 72.2 17.2 71.7 17.2L60.5 17.2C60.5 17.2 59.7 17.2 59.2 16.5C58.8 16 58.9 15.4 58.9 15.4L58.9 3.2L73.3 3.2L73.3 3.2ZM5.4 3.2L5.4 5L16.8 5L16.8 12.3C16.8 13 16.6 15.8 12.1 15.8C7.4 15.8 7.2 12.9 7.2 12.3L7.2 11.1L5.4 11.1L5.4 15.4C5.4 15.8 5.4 16.3 5.7 16.6C6.1 17 6.5 17.2 7 17.2L18.2 17.2C18.2 17.2 19 17.2 19.5 16.5C19.9 16 19.8 15.4 19.8 15.4L19.8 3.2L5.4 3.2L5.4 3.2Z" fill="#000000" fill-rule="evenodd" opacity="1" stroke="none"/></g></svg>',
                fontColor: [[60, 149, 179], [60, 149, 179], [60, 149, 179]],
                font: 'Filson W04 Regular',
                coverPicture: '',
                imgPrefix: "https://www.projekt14.de/austausch/quick_j/JUNG_",
                name: project.projectName || project.name,
                projectType: project.projectType,
                coverUrl: "https://projekt14.de/austausch/quick_j/pdf_cover/home-2.jpg"
            },
            ["hersteller", "mergePdf", "pdfFiles", "planungscode", "additionalPages", "bgImage", "content", "type", "value", "blueColor", "pdfLogo", "fontColor", "font", "coverPicture", "imgPrefix", "name", "projectType", "coverUrl"]);

        fetch(
            process.env.REACT_APP_QUICK_BACKEND_URL + "/download/pflichtenheft_quick",
            {
                method: "post",
                body: products
            }
        ).then( (res)  => {
                res.blob().then((blob) => {
                    // const filename = dispo.slice(("attachment; filename=\"").length, dispo.length - 1);
                    const d = new Date();
                    d.toLocaleString();
                    let year = d.getFullYear();
                    let month = d.getMonth();
                    let day = d.getDate();

                    month += 1;

                    let filename = "JUNG";
                    if (project.projectType === "knx") { filename += '-KNX_'; }
                    if (project.projectType === "konventionell") { filename += '_'; }
                    if (project.projectType === "home") { filename += '-HOME_'; }
                    let projectname = project.projectName || project.name;
                    projectname = projectname.split(' ').join('_');
                    projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
                    filename += "Funktionen_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
                    filename+= ".pdf";

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        "download",
                        filename,
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setLoadingFunctions(false);
                })
            }
        )
        // ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedSpecificationBook: 1}, undefined, trackingObj);
    }
    function downloadCSV(){
        if (!planungsCode && !pCode) {
            callFunction = 'downloadCSV';
            saveProject();
            return;
        }
        let filterData = productListAndFiltersAll ? productListAndFiltersAll : {...productListAndFilters, calculatedValues: calculatedValues, totals: totals};
        let jsonData = "Lfd.Nr.;" + (filterData.isAllRooms ? 'Raum;' : "") + "Artikelnummer;Bezeichnung;UVP;Anzahl;Summe;\n";
        let lfdnr = 0;
        setLoadingCSV(true);
        filterData.productList.forEach( g => {
            g.products.forEach(p => {
                if (!p.isOptional) {
                    lfdnr += 1;
                    let gesamtpreis = round(p.Preis / 100 * p.count);
                    if (parseFloat(gesamtpreis.replace(',', '.')) < 0) { gesamtpreis = 'Ohne Angabe'; }
                    let formatierterPreis = round(p.Preis / 100);
                    if (parseFloat(formatierterPreis.replace(',', '.')) < 0) { formatierterPreis = 'Ohne Angabe'; }
                    let formatierteBezeichnung = keineUmlaute(p.Bezeichnung);
                    if (!filterData.isAllRooms) {
                        jsonData += lfdnr + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    } else {
                        jsonData += lfdnr + ";" + (p.floorName + ' - ' + p.roomName) + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    }
                }
            })
        })
        jsonData += "\n";
        let extraChar = filterData.isAllRooms ? ';' : '';
        if(currentProject.projectType === 'knx' || currentProject.projectType === 'easy' || currentProject.projectType === 'home' ){
            jsonData += ";;;;Summe (netto);" + filterData.totals.nettopreis + "" + extraChar + "\n";
            jsonData += ";;;;MwSt (19%);" + filterData.totals.mwst + "" + extraChar + "\n";
            jsonData += ";;;;Gesamtsumme;" + filterData.totals.gesamtsummeohnebeg + "" + extraChar + "\n";
            jsonData += ";;;;BEG-Foerderung;" + filterData.totals.beg + "" + extraChar + "\n";
            jsonData += ";;;;Gesamtsumme;" + filterData.totals.gesamtsumme + "" + extraChar + "\n";
        }else if (currentProject.projectType === 'konventionell'){
            jsonData += ";;;;Summe (netto);" + filterData.totals.nettopreis + "" + extraChar + "\n";
            jsonData += ";;;;MwSt. (19%);" + filterData.totals.mwst + "" + extraChar + "\n";
            jsonData += ";;;;Gesamtsumme;" + filterData.totals.gesamtsummeohnebeg + "" + extraChar + "\n";
        }

        if (filterData.optionalProducts.length) {
            jsonData += "\n";
            jsonData += ";Optionale Produkte;;;;;\n";
            jsonData += "Lfd.Nr.;" + (filterData.isAllRooms ? 'Raum;' : "") + "Artikelnummer;Bezeichnung;UVP;Anzahl;Summe;\n";
            let lfdnr2 = 0;
            let netto = 0; let mwst; let gesamtsummeohnebeg;
            filterData.optionalProducts.forEach( g => {
                g.products.forEach(p => {
                    lfdnr2 += 1;
                    netto += (p.Preis / 100) * p.count;
                    let gesamtpreis = round(p.Preis / 100 * p.count);
                    let formatierterPreis = round(p.Preis / 100);
                    let formatierteBezeichnung = keineUmlaute(p.Bezeichnung);
                    if (!filterData.isAllRooms) {
                        jsonData += lfdnr2 + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    } else {
                        jsonData += lfdnr2 + ";" + (p.floorName + ' - ' + p.roomName) + ";" + p.Artikelnummer + ";" + formatierteBezeichnung + ";" + formatierterPreis + ";" + p.count + ";" + gesamtpreis + ";\n";
                    }
                })
            });
            mwst = netto * 0.19;
            gesamtsummeohnebeg = netto + mwst;
            jsonData += "\n";
            let extraChar = filterData.isAllRooms ? ';' : '';
            jsonData += ";;;;Summe (netto);" + round(netto) + "" + extraChar + "\n";
            jsonData += ";;;;MwSt. (19%);" + round(mwst) + "" + extraChar + "\n";
            jsonData += ";;;;Gesamtsumme;" + round(gesamtsummeohnebeg) + "" + extraChar + "\n";
            jsonData += "\n";
        }
        jsonData += ";;Planungscode: " + (planungsCode ? planungsCode : pCode) + ";;;" + extraChar + "\n";
        jsonData += ";;Raum: " + (filterData.room !== 'alle' ? filterData.room : "Gesamt\u00fcbersicht") + ";;;" + extraChar + "\n";
        jsonData += ";;Produkt: " + (filterData.product ? filterData.product : "alle Produkte") + ";;;" + extraChar + "\n";

        let csvFile = "data:text/csv;charset=utf-8,";

        csvFile = jsonData;

        const d = new Date();
        d.toLocaleString();
        let year = d.getFullYear();
        let month = d.getMonth();
        let day = d.getDate();

        month += 1;

        let filename = "JUNG";
        if (project.projectType === "knx") { filename += '-KNX_'; }
        if (project.projectType === "konventionell") { filename += '_'; }
        if (project.projectType === "home") { filename += '-HOME_'; }
        let projectname = project.projectName || project.name;
        projectname = projectname.split(' ').join('_');
        projectname = projectname.length > 30 ? projectname.slice(0, 30) : projectname;
        filename += "Stueckliste_" + projectname + "_" + year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
        filename += '.csv';

        let blob = new Blob(["\ufeff" + csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoadingCSV(false);
            }
        }
        // ProjectSaveService.saveTracking({trackingId: trackingObj.trackingId, downloadedCsv: 1}, undefined, trackingObj);
    }
    function CSVFree() {
        return <>Stückliste</>;
    }
    function CSVBusy() {
        return <div className="btn_loading"></div>;
    }
    function getCSVButtonLabel() {
        if (loadingCSV) { return <CSVBusy/>; }
        return <CSVFree/>;
    }
    function RoomBookFree() {
        return <>Raumbuch</>;
    }
    function RoomBookBusy() {
        return <CSVBusy/>;
    }
    function getRoomBookButtonLabel() {
        if (loadingRoomBook) { return <RoomBookBusy/>; }
        return <RoomBookFree/>;
    }
    function getFunctionsButtonLabel() {
        if (loadingFunctions) { return <RoomBookBusy/>; }
        return <>Funktionsbuch (PDF)</>;
    }
    function selectFunctionFilterValue(id) {
        setSelectedFunctionCat(id);
    }
    function generateFunktionenFilter() {
        const list = [];
        list.push(<MenuItem value={"functionsFilter-all"} key={"functionsFilter-all"} style={{fontSize: "inherit"}} className={"functionsFilterItem"} onClick={e => selectFunctionFilterValue(undefined)}>Anwendungsbereich</MenuItem>);
        if (currentProject.functionsCats) {
            Object.keys(currentProject.functionsCats).forEach(key => {
                const f = currentProject.functionsCats[key];
                const cat = matrix_files.filter(i => i.id === f.cat)[0];
                list.push(<MenuItem value={cat.id} key={cat.id} style={{fontSize: "inherit"}}
                                         className={"roomFilterFloorItem"}
                                         onClick={e => selectFunctionFilterValue(cat.id)}
                >{cat.cat}</MenuItem>);
            });
        }
        return list;
    }
    function GenerateFilteredFunctionen() {
        let html = [];
        Object.keys(currentProject.functionsCats).forEach(key => {
            const f = currentProject.functionsCats[key];
            if (f.cat === selectedFunctionCat || !selectedFunctionCat) {
                f.files.forEach(r => {
                    const file = matrix_files.filter(i => i.id === r)[0];
                    if (file) {
                        html.push(<div className={"row"} style={{width: '100%', color: 'var(--textColor)', background: 'var(--weiss)', padding: '15px 0', marginBottom: '1px'}}>
                            <div className={"col-1 phoneNoShow"} style={{width: '200px', paddingLeft: '15px'}}><img src={funcImgUrl + file.image} style={{width: '100%'}} alt={""} /></div>
                            <div className={"col-2 phone-plr-10"} style={{paddingLeft: '15px'}}>{file.cat}</div>
                            <div className={"col-2 phoneNoShow"}>{file.title}</div>
                            <div className={"col-7"} style={{paddingRight: '15px'}}><p className={"phoneShow"} style={{marginTop: '0'}}>{file.title}</p> {file.text}</div>
                        </div>);
                    }
                });
            }
        });
        return html;
    }
    const CircleButton = withStyles((theme) => ({
        root: {
            cursor: "pointer",
            borderRadius: "22px",
            width: "22px",
            height: "22px",
            textAlign: "center",
            border: "none",
            minWidth: "unset",
            overflow: "hidden",
            padding: "0 0 0 4px",
            margin: "0 7px 0 2px"
        },
    }))(Button);
    function onSubmitHandler(e) {
        if (!(planungsCode || pCode)) {
            callFunction = 'submitForm';
            saveProject();
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }
    function submitForm() {
        // ProjectSaveService.saveTracking({
        //     trackingId: trackingObj.trackingId,
        //     merchant: 1
        // }, null, trackingObj);
        setTimeout(() => {
            // partnerForm.dispatchEvent(new Event('submit', { cancelable: true }));
            document.getElementById('btnSubmit').click();
        }, 100);
    }
    function getProjectType(){
        const typ = project.projectType.replace('konventionell', 'schalter');
        let retVal = 'Smart Home Installation';
        switch (typ) {
            case 'home': retVal = 'Smart Home Installation'; break;
            case 'schalter': retVal = 'Smart Schalter Installation'; break;
            case 'knx': retVal = 'Smart KNX Installation'; break;
        }
        return retVal;
    }
    function getPlanungsCode() {
        return '' + (pCode || planungsCode || prCode);
    }
    function toggleProjektboerse(e) {
        if (!boerseOpen) {
            setBoersePage(1);
        }
        setBoerseOpen(!boerseOpen);
    }
    function handleBoerseClose(e) {
        e.preventDefault(); e.stopPropagation();
        setBoerseOpen(false);
        return false;
    }
    function sendBoerseResult(response, token = null) {
        console.log('boerseresult', response);
        if (response.violations) {
            for (let i = 0; i < response.violations.length; i++) {
                const violation = response.violations[i];
                document.getElementById(violation.propertyPath).style.border = '1px solid #dc3545';
                document.getElementById(violation.propertyPath + "_error").innerHTML = violation.message;
            }
            return false;
        }
        setBoersePage(2);
        // const images = [
        //     '/images/projektboerse/01.jpg', '/images/projektboerse/02.jpg', '/images/projektboerse/03.jpg',
        //     '/images/projektboerse/04.webp', '/images/projektboerse/05.webp', '/images/projektboerse/06.webp', '/images/projektboerse/07.webp',
        //     '/images/projektboerse/08.jpg', '/images/projektboerse/09.jpg',
        // ];
        // const rand1 = Math.floor(Math.random() * 8);
        // const rand2 = Math.floor(Math.random() * 8);
        // const rand3 = Math.floor(Math.random() * 8);
        // const rand4 = Math.floor(Math.random() * 8);
        // const files = [
        //     {file: images[rand1], altText: 'altText 1', titleText: 'Img 1'},
        //     {file: images[rand2], altText: 'altText 2', titleText: 'Img 2'},
        //     {file: images[rand3], altText: 'altText 3', titleText: 'Img 3'},
        //     {file: images[rand4], altText: 'altText 4', titleText: 'Img 4'},
        // ];
        // console.log('images', images, img01, rand1, rand2, images[rand1], images[rand2])
        // ProjectBoerseService.uploadImages(files, response, token !== null ? token : currentToken, setBoersePage);
    }
    function prepareBoerseData(formData, response) {
        // console.log('formdata', formData, response)
        // setTimeout(() => {sendBoerseResult({'@id': '/api/projekt/018cc97f-6b4c-7f41-87d7-9a64c4ae1982'}, response.token)}, 1000);
        const projectType = response.projectType[0];
        const werte = [];
        projectType.zusaetzlicheProjektEigenschaften.forEach(zpe => {
            switch (zpe.name) {
                case 'Art der Baustelle':
                    werte.push({ // art der baustelle, ex. Mehrfamillienhaus
                        projektEigenschaft: zpe['@id'],
                        value: project.name
                    });
                break;
                case 'Gebäude-Typ':
                    werte.push({ // gebaeude-typ, ex. Neubau
                        projektEigenschaft:zpe['@id'],
                        value: project.subProjectType === 'neubau' ? 'Neubau' : 'Umbau im Bestand'
                    });
                break;
                case 'Projektname':
                    werte.push({ // projektname, ex. Neubau Haus smart zu machen
                        projektEigenschaft: zpe['@id'],
                        value: project.projectName !== '' ? project.projectName : project.name
                    });
                break;
                case 'PLanungslink für alunio-Accountinhaber':
                    werte.push({ // myJung planungslink
                        projektEigenschaft: zpe['@id'],
                        value: 'https://' + window.location.host + '/home/myjung/' + (planungsCode ? planungsCode : pCode)
                    });
                break;
                case 'Öffentlicher Planungslink':
                    werte.push({ // oeffentlicher planungslink
                        projektEigenschaft: zpe['@id'],
                        value: 'https://' + window.location.host + '/home/' + (planungsCode ? planungsCode : pCode)
                    });
                break;
            }
        });
        const gewerke = [];
        response.gewerke.forEach(g => gewerke.push(g['@id']));
        const sendData = {
            titel: project.projectName !== '' ? project.projectName : project.name,
            untertitel: 'Gesucht: Handwerker/in zur Schadenssanierung',
            extReferenzId: planungsCode ? planungsCode : pCode,
            umsatzpotenzial: parseInt(totals.gesamtsummeohnebeg.replace('.','').replace(',',''),10),
            strasse: formData.differentAddress.checked ? formData.strasse.value : formData.kontaktStrasse.value,
            hausnummer: formData.differentAddress.checked ? formData.hausnummer.value : formData.kontaktHausnummer.value,
            plz: formData.differentAddress.checked ? formData.plz.value : formData.kontaktPlz.value,
            ort: formData.differentAddress.checked ? formData.ort.value : formData.kontaktOrt.value,
            kontaktAnrede: formData["gender[]"].value,
            kontaktVorname: formData.kontaktVorname.value,
            kontaktNachname: formData.kontaktNachname.value,
            kontaktEmail: formData.kontaktEmail.value,
            kontaktStrasse: formData.kontaktStrasse.value,
            kontaktHausnummer: formData.kontaktHausnummer.value,
            kontaktPlz: formData.kontaktPlz.value,
            kontaktOrt: formData.kontaktOrt.value,
            projektTyp: projectType['@id'],
            projektEigenschaftWerte: werte,
            qualifikationen: [],
            // status: "/api/projekt_statuses/018cb05c-e452-78c9-8cde-02a6dc235358",
            gewerke: gewerke,
            projektArt: "Angebot",
            beschreibung: "Bei diesem Projekt handelt es sich um ein Alunio Projekt. Der gewünschte Umfang wird in den Planungsunterlagen beschrieben (siehe Planungslink)."
        };
        ProjectBoerseService.sendProject(sendData, response.token, sendBoerseResult);
    }
    function gotLogin(data, response) {
        // console.log('got response', response);
        if (response.token) {
            setCurrentToken(response.token);
            prepareBoerseData(data, response);
        }
    }
    function handleBoerseSubmit(event) {
        event.preventDefault(); event.stopPropagation();
        if (!planungsCode && !pCode) {
            callFunction = 'submitBoerseForm';
            saveProject();
            return false;
        }
        ProjectBoerseService.sendLogin(event.target.elements, gotLogin);
        return false;
    }
    function sendBoerseForm(e) {
        document.getElementById('boerseForm').requestSubmit();
    }
    function toggleProjektort() {
        setProjektOrt(!projektOrt);
    }
    return <>
        <div className={"last-page-container pb-15"}>
            <div className={"padding-container"}>
                <div className={"border-bottom pb-15 mb-15"}>
                    <div className={"section-title"} style={{marginBottom: '5px'}}>Produktlisten</div>
                    <div className={"section-text"}>Die Auswahl Ihrer favorisierten Geräte finden Sie hier in detaillierter Auflistung:</div>
                </div>
                <div className="equimentBoxHeader" onClick={(e) => onOpenClose(e)}>
                    <div className="openClose">
                        {isOpen ? <CircleButton>
                            <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                        </CircleButton> : <CircleButton>
                            <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                        </CircleButton> }
                    </div>
                    <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>{isOpen ? "Ausgewählte Produkte im Projekt ausblenden" : "Ausgewählte Produkte im Projekt anzeigen"}</span>
                </div>
                {isOpen ? <div className={"step5SelectWrapper filterWrapper row"}>
                    <div className={"step5SelectItem col-1"}>
                        <Select defaultValue="alle" id="grouped-select-room" style={{display:"block"}}>
                            {generateRoomFilter(productListAndFilters.roomFilterList)}
                        </Select>
                    </div>
                    <div className={"step5SelectItem col-1"}>
                        <Select defaultValue={"productFilter-all"} id="grouped-select-product" style={{display:"block"}}>
                            {generateProductFilter(productListAndFilters.catFilterList, productListAndFilters.isAllRooms)}
                        </Select>
                    </div>
                </div> : null}
                <div className={"product-list-opened"}>
                {isOpen ? <>
                        {(!productListAndFilters.isAllRooms ? <>{generateGroupList()}</> : <>{generateRoomList()}</>)}
                        <div className="equimentBoxHeader" onClick={onOpenClose} style={{marginTop: '15px'}}>
                            <div className="openClose">
                                {isOpen ? <CircleButton>
                                    <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                    <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                                </CircleButton> : <CircleButton>
                                    <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                    <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                                </CircleButton> }
                            </div>
                            <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>{isOpen ? "Ausgewählte Produkte im Projekt ausblenden" : "Ausgewählte Produkte im Projekt anzeigen"}</span>
                        </div>
                    </>
                    : null}
                </div>
            </div>
        </div>
        {project.projectType === 'home' ? <div className={"fs-container mt-15 ptb-25"}>
            <div className={"padding-container"}>
                <div className={"border-bottom pb-15 mb-15"}>
                    <div className={"section-title"} style={{marginBottom: '5px'}}>Funktionsliste</div>
                </div>
                <div className="equimentBoxHeader" onClick={onFunktionenToggle}>
                    <div className="openClose">
                        {isFunktionenOpen ? <CircleButton>
                            <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                        </CircleButton> : <CircleButton>
                            <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                            <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                        </CircleButton> }
                    </div>
                    <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>{isOpen ? "Mit Ihrer Geräte-Auswahl lassen sich unter Anderem folgende Funktionen umsetzen." : "Mit Ihrer Geräte-Auswahl lassen sich unter Anderem folgende Funktionen umsetzen."}</span>
                </div>
                {isFunktionenOpen ? <>
                    {Object.keys(currentProject.functionsCats).length
                        ? <div className={"step5SelectWrapper filterWrapper row phone-small"}>
                            <div className={"step5SelectItem col-1"} style={{maxHeight: '45px', padding: '0 10px'}}>
                                <Select defaultValue="functionsFilter-all" id="grouped-select-room" style={{display:"block", paddingTop: '8px'}}>
                                    {generateFunktionenFilter()}
                                </Select>
                            </div>
                            <div className={"step5SelectItem col-1"} style={{maxHeight: '45px', background: 'transparent',}}></div>
                            <div className={"step5SelectItem col-1"} style={{maxHeight: '45px', background: 'transparent', padding: '0 10px'}}>
                                <ColorButton4 type="submit" onClick={downloadFunctions} style={{width: '100%', marginTop: '0', borderRadius: '5px'}}>{getFunctionsButtonLabel()}</ColorButton4>
                            </div>
                        </div>
                        : <>
                            <div style={{padding: '30px 0 15px', color: 'var(--textColor)'}}>Keine Einträge vorhanden. Ändern Sie Ihre Geräteauswahl/Konfiguration.</div>
                        </>
                    }
                </> : null}
                <div className={"product-list-opened"}>
                {isFunktionenOpen && Object.keys(currentProject.functionsCats).length ? <>
                    <div className="equimentBoxHeader" style={{width: '100%', flexDirection: 'column', marginTop: '15px'}}>
                        <div className={"row"} style={{width: '100%', color: 'var(--textColor)', paddingBottom: '15px'}}>
                            <div className={"col-1 phoneNoShow"} style={{minWidth: '95px', textAlign: "right"}}>Anwendung</div>
                            <div className={"col-2 phone-plr-10"} style={{textAlign: "center"}}>Bereich</div>
                            <div className={"col-2 phoneNoShow"} style={{textAlign: "center"}}>Titel</div>
                            <div className={"col-7 phone-talign-left"} style={{textAlign: "center"}}>Welche Funktion steckt dahinter?</div>
                        </div>
                        {<GenerateFilteredFunctionen />}
                    </div>
                    <div className="equimentBoxHeader" onClick={onFunktionenToggle} style={{marginTop: '15px'}}>
                        <div className="openClose">
                            {isFunktionenOpen ? <CircleButton>
                                <img className="icon-to-page-bottom" src={uarrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                <img className="icon-to-page-bottom only-hover" src={uarrh} alt={""} width="25"/>
                            </CircleButton> : <CircleButton>
                                <img className="icon-to-page-bottom" src={darrh} alt={""} width="25" style={{marginRight: "-22px"}} />
                                <img className="icon-to-page-bottom only-hover" src={darrh} alt={""} width="25"/>
                            </CircleButton> }
                        </div>
                        <span className={"section-text"} style={{fontWeight: "bold", marginLeft: "5px", paddingTop: '0'}}>Funktionen ausblenden</span>
                    </div>
                </>
                : null}
                </div>
            </div>
        </div> : null}
        {window.innerWidth < 800 ? <PriceBox opener={true} /> : null}
        {/*<div className={"fs-container ptb-25" + (project.projectType !== 'konventionell' ? ' mt-15' : '')}>*/}
        {/*    <div className="padding-container p40">*/}

        {/*    </div>*/}
        {/*</div>*/}
        <div className="fs-container mt-15 ptb-25">
            <div className="padding-container p40">
                <div className="row planungscode">
                    <div className="col-6" style={{display: 'flex', flexDirection: 'column'}}>
                        <div className="section-title">Planungsunterlagen</div>
                        <div className="section-text mb-15">Als Vorbereitung auf die Installation in Ihrem Bauvorhaben laden Sie folgende Unterlagen herunter:</div>
                        <div className={"exportButtons"}>
                            {isMyJung ? <ColorButton4Disabled onClick={downloadCSV}>{getCSVButtonLabel()}</ColorButton4Disabled> : null}
                            <ColorButton4Disabled type="submit" onClick={downloadPdf}>{getRoomBookButtonLabel()}</ColorButton4Disabled>
                            {project.projectType === 'home' ? <>
                                {Object.keys(currentProject.functionsCats).length
                                    ? <ColorButton4 type="submit" onClick={downloadFunctions}>{getFunctionsButtonLabel()}</ColorButton4>
                                    : <ColorButton4Disabled type="submit">{getFunctionsButtonLabel()}</ColorButton4Disabled>
                                }
                            </> : null}
                        </div>
                    </div>
                    <div className="col-6 pl45px">
                        <div className="section-title">Planungscode</div>
                        <div className="section-text mb-15">Mit dem Planungscode können Sie jederzeit selbst oder<br/>zusammen mit dem Elektroinstallateur Ihre Planung anpassen.</div>
                        <div className={"exportButtons"}>
                            <div className={"col"}>
                                { planungsCode || pCode || prCode ?
                                    <>
                                        <div style={{position: "relative", fontSize: '20px', color: 'var(--captionColor)', top: "5px"}}>
                                            <span className={"bold"}>{prCode ? prCode : (planungsCode ? planungsCode : pCode)}</span>
                                            <CopyIconSVG/>
                                            {inClipboard ? <InClipboardNotice/> : null}
                                        </div>
                                    </>
                                    : <div style={{textAlign: "center", width: 'calc(100% - 10px)'}} className="justmobilearrow">
                                        <ColorButton41 onClick={e => saveProject()}>
                                            Code generieren
                                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                                <g transform="translate(1226 294.034) rotate(180)">
                                                    <rect width="33" height="30" transform="translate(1193 264.034)" fill="transparent"/>
                                                    <path d="M12.859,8.077l.679.679a.731.731,0,0,1,0,1.037L7.6,15.738a.731.731,0,0,1-1.037,0L.613,9.792a.731.731,0,0,1,0-1.037l.679-.679a.735.735,0,0,1,1.049.012l3.511,3.686V2.984a.732.732,0,0,1,.734-.734h.979a.732.732,0,0,1,.734.734v8.79L11.81,8.089A.73.73,0,0,1,12.859,8.077Z" transform="translate(1202.715 269.608)" fill="#fff"/>
                                                </g>
                                            </svg>
                                        </ColorButton41>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {/*<div className="col-6" style={{maxWidth: '270px'}}>*/}
                    {/*    <div className="section-title">Installation</div>*/}
                    {/*    <div className="section-text mb-15">Für Ihre Installation empfehlen wir Ihnen gern Fachbetriebe aus Ihrer Umgebung.</div>*/}
                    {/*    <div className={"exportButtons"}>*/}
                    {/*        <div style={{textAlign: "center", width: "calc(100% - 0px)", marginLeft: '0px', display: "flex"}}>*/}
                    {/*            <ColorButton41 onClick={openUrl('https://www.mein-elektroinstallateur.de/')}>Unverbindlich anfragen</ColorButton41>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
        {!isMyJung && !isProjektboerse ? <div className="fs-container mt-15 p0 last-banner">
            <div className={"col-12"}>
                <div className={"lastbanner"}>
                    <img className={"bannerimage"} alt="people" src="/images/design/People.png" width="435px" />
                    <form id={"partnerform"} action={process.env.REACT_APP_QUICK_FIND_PARTNER_URL} method="post" target={"_blank"} onSubmit={onSubmitHandler} ref={ref => setPartnerForm(ref)}>
                        <input type={"hidden"} name={"project_code"} value={getPlanungsCode()}/>
                        <input type={"hidden"} name={"project_source"} value={getProjectType()}/>
                        <input type={"hidden"} name={"token"} value={currentSha1} />
                        <div className={"form"}>
                            <div className={"section-title"}>Jung Fachpartner finden</div>
                            <div className={"section-text"}>Wenden Sie sich mit Ihrer Konfiguration an einen Fachbetrieb in der Umgebung. Nutzen Sie dafür unseren Service:</div>
                            <div className={"form-row"}>
                                <div className={"section-text only-mobile"}>PLZ oder Stadt</div>
                                <input name={"place"} placeholder={"PLZ oder Stadt"} />
                                <ColorButton42 className={"btn-send"} type={"submit"} id={"btnSubmit"}>
                                    <span>Suchen</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                        <g transform="translate(1226 294.034) rotate(180)">
                                            <rect width="33" height="30" transform="translate(1193 264.034)" fill="transparent"/>
                                            <path d="M12.859,8.077l.679.679a.731.731,0,0,1,0,1.037L7.6,15.738a.731.731,0,0,1-1.037,0L.613,9.792a.731.731,0,0,1,0-1.037l.679-.679a.735.735,0,0,1,1.049.012l3.511,3.686V2.984a.732.732,0,0,1,.734-.734h.979a.732.732,0,0,1,.734.734v8.79L11.81,8.089A.73.73,0,0,1,12.859,8.077Z" transform="translate(1202.715 269.608)" fill="#fff"/>
                                        </g>
                                    </svg>
                                </ColorButton42>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div> : null}
        <a ref={boerseRef}></a>
        {isProjektboerse ? <>
            <div className="fs-container mt-15 ptb-25" id={"boersecontainer"}>
                <div className="padding-container p40">
                    <div className="row planungscode">
                        <div className="col-6" style={{display: 'flex', flexDirection: 'column'}}>
                            <div className="section-title">Elektroinstallateur-Vermittlung</div>
                            <div className="section-text mb-15">Projektbörse.de bietet Ihr Projekt bei Elektroinstallateuren in Ihrer Umgebung an und vermittelt einen Sichtungstermin für eine Projektbesprechung und Angebotserstellung.</div>
                            <div className={"exportButtons"}>
                                {<BtnProjektBoerse onClick={(e) => toggleProjektboerse(e)}>Jetzt Projekt-Steckbrief erstellen</BtnProjektBoerse>}
                            </div>
                        </div>
                        <div className="col-6" style={{paddingLeft: '20%'}}>
                            <img src={boerseImg} height="100%" />
                        </div>
                    </div>
                </div>
            </div>
        </>: null}
        {isProjektboerse ? <>
            <Popover id="boersePopover" open={boerseOpen} anchorEl={boerseElement} onClose={handleBoerseClose}
                     anchorOrigin={{
                         vertical: 'center',
                         horizontal: 'center',
                     }}
                     style={{maxWidth: '100%', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.75)'}}
                     className={boersePage === 2 ? "succeeded" : ""}
            >
                <div className={"popoverContainer"} style={{position: 'relative'}}>
                    <div className={"popoverHeader"}>
                        <div className={"images"}>
                            <img src={jungLogo} className={"left"} height="35" />
                            <img src={boerseLogox} className={"left"} height="35" style={{margin: "0", maxHeight: '20px'}} />
                            <img src={boerseLogo2} className={"right"} />
                        </div>
                        <a href="#" onClick={handleBoerseClose} style={{color: 'var(--blueColor)'}}><CloseIcon /></a>
                    </div>
                    {boersePage === 1 ? <div className={"page-1"}>
                        <p className={"title-pb"}>Ihr ALUNIO-Projekt: Vermittlung leicht gemacht</p>
                        <p>Projektbörse.de präsentiert Ihre Alunio-Planung Elektroinstallateuren in Ihrer Umgebung und koordiniert einen Besichtigungstermin für eine ausführliche Projektbesprechung und komplette Angebotserstellung. So bringen wir Ihr smartes Zuhause einen Schritt näher!</p>
                        <input type="text" disabled="disabled" value={project.projectName !== '' ? project.projectName : project.name} className={"noform"} style={{marginTop: '5px'}} />
                        <form id={"boerseForm"} action={"/"} method={"post"} onSubmit={handleBoerseSubmit}>
                            <p className={"title-pb"}>E-Mailadresse</p>
                            <p>Sobald sich ein Elektroinstallateur für Ihr Projekt interessiert, werden Sie ausschließlich per E-Mail informiert mit einem Terminvorschlag des Handweriers.</p>
                            <input type="text" id={"kontaktEmail"} name={"kontaktEmail"} required={"required"} placeholder={"E-Mailadresse*"} style={{marginTop: '5px'}} />
                            <input type="text" id={"kontaktEmailRepeat"} name={"kontaktEmailRepeat"} required={"required"} placeholder={"E-Mailadresse wiederholen*"} style={{marginTop: '5px', marginBottom: '5px !important'}} autocomplete={"off"} />
                            <div className="error" id={"kontaktEmail_error"}></div>
                            <p className={"title-pb"}>Kontaktdaten / Projektort</p>
                            <p>Diese Daten werden ausschließlich genutzt, um Ihr Projekt Handwerkern in Ihrer Nähe anzubieten. Und einem interessierten Handwerker die Kontaktaufnahme zu ermöglichen.</p>
                            <div className={"radios"} id={"kontaktAnrede"} style={{marginTop: '5px'}}>
                                <label><input type="radio" name={"gender[]"} value={"Herr"} required={"required"} /> Herr</label>
                                <label><input type="radio" name={"gender[]"} value={"Frau"} required={"required"} /> Frau</label>
                                <label><input type="radio" name={"gender[]"} value={"Divers"} required={"required"} /> Divers</label>
                            </div>
                            <div className="error" id={"kontaktAnrede_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktVorname"} name={"kontaktVorname"} required={"required"} placeholder={"Vorname*"} />
                            <div className="error" id={"kontaktVorname_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktNachname"} name={"kontaktNachname"} required={"required"} placeholder={"Name*"} />
                            <div className="error" id={"kontaktNachname_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktStrasse"} name={"kontaktStrasse"} required={"required"} placeholder={"Straße*"} />
                            <div className="error" id={"kontaktStrasse_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktHausnummer"} name={"kontaktHausnummer"} required={"required"} placeholder={"Hausnummer*"} />
                            <div className="error" id={"kontaktHausnummer_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktPlz"} name={"kontaktPlz"} required={"required"} placeholder={"PLZ*"} />
                            <div className="error" id={"kontaktPlz_error"}></div>
                            <input className={"fields"} type="text" id={"kontaktOrt"} name={"kontaktOrt"} required={"required"} placeholder={"Ort*"} />
                            <div className="error" id={"kontaktOrt_error"}></div>
                            <label className={"toggler"}>
                                <input type="checkbox" value={"projektort_abweichend"} onChange={toggleProjektort} name={"differentAddress"} />
                                (Abweichenden Projektort eingeben)
                            </label>
                            {projektOrt ?
                            <div className={"projektort"}>
                                <input className={"fields"} type="text" id={"strasse"} name={"strasse"} required={"required"} placeholder={"Straße*"} />
                                <div className="error" id={"strasse_error"}></div>
                                <input className={"fields"} type="text" id={"hausnummer"} name={"hausnummer"} required={"required"} placeholder={"Hausnummer*"} />
                                <div className="error" id={"hausnummer_error"}></div>
                                <input className={"fields"} type="text" id={"plz"} name={"plz"} required={"required"} placeholder={"PLZ*"} />
                                <div className="error" id={"plz_error"}></div>
                                <input className={"fields"} type="text" id={"ort"} name={"ort"} required={"required"} placeholder={"Ort*"} />
                                <div className="error" id={"ort_error"}></div>
                            </div>
                            : null}
                            <label className={"checkers"}>
                                <input type="checkbox" value="1" name={"accepted_agb"} required={"required"} style={{width:'21px !important', backgroundColor:'red'}} />
                                <div>Mit meiner Projektübersendung akzeptiere ich die <a href={"https://qm.xn--projektbrse-yfb.de/nutzungsbedingungen"} target={"_blank"}>Nutzungsbedingungen</a> von projektbörse.de</div>
                            </label>
                            <label className={"checkers"}>
                                <input type="checkbox" value="1" name={"accepted_datenschutz"} required={"required"} />
                                <div>Ich akzeptiere die <a href={"https://qm.xn--projektbrse-yfb.de/datenschutz"} target={"_blank"}>Datenschutzbestimmungen</a></div>
                            </label>
                            <p></p>
                            <p>Überprüfen Sie Ihre Angaben und starten Sie die Vermittlung Ihres Projektes auf projektbörse.de</p>
                        </form>
                    </div> : null}
                    {boersePage === 2 ? <div className={"page-2"}>
                        <div className={"title-pb2"}>
                            <p className={"title"} style={{textAlign: 'center'}}>Ihr Projekt ist auf dem Weg!</p>
                            <img src={page2Checker} height={"80"} alt={""} style={{margin: "10px auto 30px"}} />
                            <p className={"subtitle"}>Ihr Vorhaben wird jetzt Elektroinstallateuren in Ihrer Region angeboten. Wir drücken die Daumen, dass sich schon bald ein Handwerker bei Ihnen per E-Mail meldet.</p>
                        </div>
                        <div className={"table"} style={{display: 'none'}}>
                            <div className={"row underlined header"}>
                                <img src={boerseLogo} />
                                <p>Angebotsanfrage</p>
                            </div>
                            <div className={"row withChecker"}>
                                <img src={boerseCircleCheck} alt={""} className={"checkerImg"} />
                                <p><strong>Projekt an projektbörse.de übermittelt</strong><br/>{boerseDatum}</p>
                            </div>
                            <div className={"row withChecker"}>
                                <img src={boerseCircle} alt={""} className={"checkerImg"} />
                                <p>Projekt reserviert von Handwerker</p>
                            </div>
                            <div className={"row withChecker"}>
                                <img src={boerseCircle} alt={""} className={"checkerImg"} />
                                <p>Sichtungstermin-Vereinbarung</p>
                            </div>
                            <div className={"row withChecker underlined"}>
                                <img src={boerseCircle} alt={""} className={"checkerImg"} />
                                <p>Projekt vermittelt</p>
                            </div>
                        </div>
                        <div className={"pb-table"}>
                            <div className={"status"}>
                                <div className={"line1"}>Status</div>
                                <div className={"line2"}>Der Projektsteckbrief wurde gesendet.</div>
                            </div>
                            <div className={"icons"}>
                                <img src={pb01} />
                                <img src={pb02} />
                                <img src={pb03} />
                                <img src={pb04} />
                            </div>
                            <div className={"status-text"}>
                                <div className={"line1"}>Nächter Schritt: E-Mailbenachrichtigung bestätigen.</div>
                                <div className={"line2"}>Sie erhalten in Kürze eine E-Mail von projektbörse.de. Diese müssten Sie bitte bestätigen, damit Ihr Projekt veröffentlicht wird.</div>
                            </div>
                            <div className={"next-steps"}>
                                <div className={"title-pb3"}>
                                    <img src={arrow_down} />
                                    <p>Weiterer Projektverlauf</p>
                                </div>
                                <div className={"step"}>
                                    <img src={iconStep1} />
                                    <div className={"step-text"}>Projekt wurde veröffentlicht.</div>
                                </div>
                                <div className={"step-divider"}><img src={stepDivider} /></div>
                                <div className={"step"}>
                                    <img src={iconStep2} />
                                    <div className={"step-text"}>Sichtungstermin wurde gesendet.</div>
                                </div>
                                <div className={"step-divider"}><img src={stepDivider} /></div>
                                <div className={"step"}>
                                    <img src={iconStep3} />
                                    <div className={"step-text"}>Sichtungstermin wurde bestätigt.</div>
                                </div>
                                <div className={"step-divider"}><img src={stepDivider} /></div>
                                <div className={"step"}>
                                    <img src={iconStep4} />
                                    <div className={"step-text"}>Projektvermittlung ist beendet.</div>
                                </div>
                            </div>
                        </div>
                    </div> : null}
                    <div className={"popoverFooter"}>
                        {boersePage === 1 ? <BtnProjektBoerse2 onClick={(e) => sendBoerseForm(e)}>Absenden <img src={arrow_right} style={{marginLeft: '5px'}} /></BtnProjektBoerse2>: null}
                        {/*{boersePage === 2 ? <BtnProjektBoerse onClick={(e) => handleBoerseClose(e)}>Schließen</BtnProjektBoerse>: null}*/}
                    </div>
                </div>
            </Popover>
        </> : null}
    </>;
}
